define('components/handlers/quick-order',[
    'jquery',
], function($) {
    $.extend(companyInfo.handlers, {
        'quick-order': function() {
            var clickedEl = $(this);
            var clickedElAction = clickedEl.data('action'); // "cached-doc" or "new-doc"
            var orgId = clickedEl.data('org-id');
            var clickedElDocType = clickedEl.closest('[data-action-cell]').data('doc-type');
            var loaderEl = clickedEl.closest('[data-action-cell]').find('[data-loading]');

            // Downloading cached document
            if (clickedElAction === 'cached-doc') {
                var docId = clickedEl.data('doc-id');
                showLoader();
                fetchDocument(docId);
            }

            // New order
            if (clickedElAction === 'new-doc') {
                showLoader();
                fetch('/orders/create', {
                        method: 'POST',
                        headers: {'Content-Type': 'application/json'},
                        body: JSON.stringify({organizationID: orgId, documentType: clickedElDocType})
                }).then(function(res, rej) {
                    if (res.ok) {
                        res.json().then(function(json) {
                            if (json.status === 'pending') {
                                // Start the initial polling
                                return startPollingOrderStatus(json.orderId);
                            } else if (json.status === 'finished') {
                                // Usually API it will not return finished order immediately, but just in case
                                fetchDocument(json.documentId);
                            } else if (json.status === 'failed') {
                                showErrorInfo(json);
                            }
                        });
                    } else {
                        return rej();
                    }
                }).catch(function(err) {
                    showErrorInfo({error: 'generic'});
                });
            }

            function startPollingOrderStatus(orderId) {
                function poll() {
                    fetch('/orders/' + orderId, {
                        headers: {'Content-Type': 'application/json'}
                    }).then(function(res, rej) {
                        if (res.ok) {
                            return res.json().then(function(json) {
                                if (json.status === 'pending') {
                                    setTimeout(poll, 2000);
                                } else if (json.status === 'finished') {
                                    fetchDocument(json.documentId);
                                } else if (json.status === 'failed') {
                                    showErrorInfo(json);
                                }
                            });
                        } else {
                            return rej();
                        }
                    }).catch(function(err) {
                        showErrorInfo({error: 'generic'});
                    });
                }

                poll();
            }

            function fetchDocument(docId) {
                fetch('/document/' + docId, {
                    headers: {'Content-Type': 'application/json'},
                }).then(function(res, rej) {
                    if (res.ok) {
                        var cd = res.headers.get('content-disposition');
                        var fileName = cd ? cd.match(/filename=(.+)/)[1] : 'document.pdf';
                        res.blob().then(function(blob) {
                            downloadDocument(blob, fileName);
                            // Change to eye icon when downloaded for the first time
                            if (clickedElAction === 'new-doc') {
                                loaderEl.addClass('hidden');
                                clickedEl.find('img').attr('src', '/gui/img/eye.svg');
                                clickedEl.data('action', 'cached-doc');
                                clickedEl.data('doc-id', docId);
                                clickedEl.removeClass('hidden');
                            } else {
                                loaderEl.addClass('hidden');
                                clickedEl.removeClass('hidden');
                            }
                            // Update the date to today
                            clickedEl.closest('[data-action-cell]')
                                .parent()
                                .find('.doc-latest-date')
                                .text((new Date()).toLocaleDateString(window.companyInfo.lang === 'de' ? 'de-DE' : 'nl-NL', {  // For some reason, across the portal, we are using NL date format when we switch to English
                                    year: 'numeric',
                                    month: '2-digit',
                                    day: '2-digit',
                                }));
                        });
                    } else {
                        return rej('error');
                    }
                }).catch(function(err) {
                    showErrorInfo({error: 'generic'});
                });
            }

            function downloadDocument(blob, fileName) {
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            }

            function showErrorInfo(err) {
                loaderEl.addClass('hidden');
                clickedEl.addClass('hidden');
                var errorInfoEl = clickedEl.closest('[data-action-cell]').find('[data-error]');
                var errorText = getErrorText(err.error);
                errorInfoEl.find('[data-tooltip-content]').text(errorText);
                errorInfoEl.removeClass('hidden');

                // Show previous action after a minute
                setTimeout(function() {
                    clickedEl.removeClass('hidden');
                    errorInfoEl.addClass('hidden');
                }, 60 * 1000);
            }

            // TODO alternatively, get translations from API by passing 'Accept-Language' header
            function getErrorText(err) {
                if (err === 'document_not_available') {
                    return window.companyInfo.lang === 'de' ? 'Das Dokument ist nicht verfügbar' : 'The document is not available';
                } else if (err === 'company_not_found') {
                    return window.companyInfo.lang === 'de' ? 'Unternehmen wurde nicht gefunden' : 'Company was not found';
                } else {
                    return window.companyInfo.lang === 'de' ? 'Das hat nicht geklappt. Bitte versuchen sie es erneut' : 'Something went wrong. Please try again';
                }
            }

            function showLoader() {
                clickedEl.addClass('hidden');
                loaderEl.removeClass('hidden');
            }

        },
    });

});

